"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const change_container_dimensions_1 = require("./change-container-dimensions");
const change_image_url_1 = require("./change-image-url");
const recalculate_warnings_1 = require("./recalculate-warnings");
const open_media_db_1 = require("./open-media-db");
const import_state_1 = require("./import-state");
const export_state_1 = require("./export-state");
const reset_image_dimensions_1 = require("./reset-image-dimensions");
const tracker_1 = require("./tracker");
const change_alternate_text_1 = require("./change-alternate-text");
function effects({ data, trackEvent, replaceVariables, openMediaDbApi, validate, }) {
    return {
        changeContainerDimensions: change_container_dimensions_1.changeContainerDimensions(),
        changeImageUrl: change_image_url_1.changeImageUrl({ replaceVariables }),
        recalculateWarnings: recalculate_warnings_1.recalculateWarnings({ validate }),
        openMediaDb: open_media_db_1.openMediaDb({ openMediaDbApi }),
        importState: import_state_1.importState({ data }),
        exportState: export_state_1.exportState({ data }),
        resetImageDimensions: reset_image_dimensions_1.resetImageDimensions(),
        tracker: tracker_1.tracker({ trackEvent }),
        changeAlternateText: change_alternate_text_1.changeAlternateText({ replaceVariables }),
    };
}
exports.effects = effects;
//# sourceMappingURL=effects.js.map